import styled from 'styled-components'
import { Grid, Typography } from '@material-ui/core'
import { irem } from '../../utils'

export const StyledPercentage = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(24)};
  color: ${props => props.theme.palette.primary.main};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(30)};
  }
`

export const StyledPA = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(12)};
  margin-top: ${props => props.theme.typography.pxToRem(-10)};
  color: ${props => props.theme.palette.primary.main};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    margin-top: ${props => props.theme.typography.pxToRem(-15)};
  }
`

export const StyledValue = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(44)};
  color: ${props => props.theme.palette.common.white};
  font-weight: 400;
  position: relative;
  padding-right: ${props => props.theme.typography.pxToRem(30)};
  align-self: flex-start;

  & > span {
    position: absolute;
    top: 8px;
    right: 0;
    color: ${props => props.theme.palette.secondary.dark};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(61)};
  }
`

export const StyledDisclaimerLink = styled.a`
  text-decoration: none;
  color: ${props => props.theme.palette.primary.main};
  text-decoration: underline;
  text-decoration-thickness: ${props => props.theme.typography.pxToRem(2)};
  text-underline-offset: ${props => props.theme.typography.pxToRem(3)};
  vertical-align: super;
  font-weight: 500;
  padding-left: ${props => props.theme.typography.pxToRem(3)};
  font-size: ${props => props.theme.typography.pxToRem(14)};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(18)};
  }
`

export const ListingHeading = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(16)};
  color: ${props => props.theme.palette.common.white};
  font-weight: ${props => props.theme.typography.fontWeightRegular};
  align-self: flex-start;
  line-height: 1.5;
  /* Reserve two lines so single- and multi-line labels keep the row aligned */
  min-height: 3em;

  & > span {
    color: ${props => props.theme.palette.primary.main};
    font-weight: ${props => props.theme.typography.fontWeightMedium};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(20)};
  }
`

export const CurrencyValue = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(44)};
  font-weight: 300;
  position: relative;
  padding-left: ${props => props.theme.typography.pxToRem(10)};
  color: ${props => props.theme.palette.text.primary};
  align-self: flex-start;
  color: ${props => props.theme.palette.common.white};

  & > span {
    font-size: ${props => props.theme.typography.pxToRem(20)};
    position: absolute;
    top: 9px;
    left: 0;
    color: ${props => props.theme.palette.primary.main};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(61)};

    & > span {
      font-size: ${props => props.theme.typography.pxToRem(30)};
      left: ${props => props.theme.typography.pxToRem(-5)};
    }
  }
`

export const StyledTopContent = styled.div`
  font-size: ${props => props.theme.typography.pxToRem(15)};
  text-align: left;
  padding-top: ${props => props.theme.typography.pxToRem(10)};
  align-self: flex-start;
  color: ${props => props.theme.palette.common.white};

  & > span {
    color: ${props => props.theme.palette.secondary.dark};
    font-weight: 500;
    padding-right: ${props => props.theme.typography.pxToRem(2)};
    display: inline-block;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    padding-top: ${props => props.theme.typography.pxToRem(20)};
    width: 100%;
  }

  & + & {
    padding-top: ${irem(5)};

    ${props => props.theme.breakpoints.up('sm')} {
      padding-top: ${irem(10)};
    }
  }

  & > a > sup {
    display: inline-block;
    text-decoration: none;
  }
`

export const StyledDisclaimerContent = styled.div`
  font-size: ${props => props.theme.typography.pxToRem(15)};
  text-align: left;
  padding-top: ${props => props.theme.typography.pxToRem(10)};
  align-self: flex-start;
  color: ${props => props.theme.palette.common.white};
  display: flex;
  align-items: baseline;

  & > span {
    color: ${props => props.theme.palette.secondary.dark};
    font-weight: 500;
    padding-right: ${props => props.theme.typography.pxToRem(2)};
    display: inline-block;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    padding-top: ${props => props.theme.typography.pxToRem(20)};
    width: 100%;
  }

  & + & {
    padding-top: ${irem(5)};

    ${props => props.theme.breakpoints.up('sm')} {
      padding-top: ${irem(10)};
    }
  }

  & > a > sup {
    display: inline-block;
    text-decoration: none;
  }
    
  p {
    margin: 0;   
  }
`

export const StyledBottomContent = styled(StyledTopContent)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
`

export const StyledTopRow = styled(Grid)`
  width: 100%;
  padding-bottom: ${props => props.theme.typography.pxToRem(25)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-bottom: ${props => props.theme.typography.pxToRem(30)};
  }
`

export const StyledCenterRow = styled(Grid)`
  ${props => props.theme.breakpoints.up('sm')} {
    padding-left: 0;
  }
`

export const StyledCenterContent = styled(Grid)`
  padding-bottom: ${props => props.theme.typography.pxToRem(20)};
  padding-right: ${props => props.theme.typography.pxToRem(25)};

  ${props => props.theme.breakpoints.down('xs')} {
      padding: 0 ${props => props.theme.typography.pxToRem(42)} ${props => props.theme.typography.pxToRem(20)} 0;

      &:nth-child(even) {
          padding-right: 0;
          padding-left: ${props => props.theme.typography.pxToRem(25)};
      }

      &:nth-last-child(-n + 2) {
          padding-bottom: 0;
      }
  }
`


export const StyledBottomRow = styled(Grid)`
  width: 100%;
  padding-top: ${props => props.theme.typography.pxToRem(21)};

  ${props => props.theme.breakpoints.up('sm')} {
  padding-top: ${props => props.theme.typography.pxToRem(41)};
  }
`

export const StyledSubtitle = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  font-weight: 500;
  line-height: ${props => props.theme.typography.pxToRem(22)};
  color: #B9B9B9;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(18)};
    line-height: ${props => props.theme.typography.pxToRem(30)};
    font-weight: 500;
    margin-top: ${props => props.theme.typography.pxToRem(20)};
  }

  margin-bottom: 0;
  margin-top: ${props => props.theme.typography.pxToRem(5)};;
  word-break: break-word;
  text-align: left;

  & strong {
    font-size: ${props => props.theme.typography.pxToRem(14)};
    font-weight: 700;

    ${props => props.theme.breakpoints.up('sm')} {
      font-size: ${props => props.theme.typography.pxToRem(18)} !important;
    }
  }

  & a {
    text-decoration: none;
  }

  & a > sup {
    text-decoration: none;
    color: ${props => props.theme.palette.primary.main};
    text-decoration: underline;
    text-decoration-thickness: ${props => props.theme.typography.pxToRem(2)};
    text-underline-offset: ${props => props.theme.typography.pxToRem(3)};
    vertical-align: super;
    font-weight: 500;
    padding-left: ${props => props.theme.typography.pxToRem(3)};
    font-size: ${props => props.theme.typography.pxToRem(14)};
  
    ${props => props.theme.breakpoints.up('sm')} {
      font-size: ${props => props.theme.typography.pxToRem(18)};
    }
  }
`

export const StyledTitle = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  line-height: ${props => props.theme.typography.pxToRem(22)};
  color: #B9B9B9;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: ${props => props.theme.typography.pxToRem(1.6)};
  margin-bottom: 0;
  margin-top: ${props => props.theme.typography.pxToRem(10)};;
  word-break: break-word;
  text-align: left;
`
